import React from "react";
import useSurveyFormContext from "../../../hooks/useSurveyFormContext"

const FormInputs = () => {

    const { data, handleChange, handleCheckboxChange, page } = useSurveyFormContext()


    const FIELD_WRAP = "mb-5"
    const INPUT_TEXT = "block w-full rounded-full bg-neutral-200 dark:bg-neutral-800 border-0 pl-6"
    const RADIO = "text-amber-500 focus:ring-transparent mr-2"
    const RADIO_TEXT_SHORT = "mr-8 whitespace-nowrap"
    const RADIO_TEXT = "mr-8"
    const LABEL = "mb-3 uppercase block text-base font-medium text-green-700 dark:text-green-500"

    const FORM_FIELDS = [
        [
            {
                type: 'email',
                label: 'Your Email',
                bind: 'email'
            },
            {
                type: 'radio',
                label: 'What is your age range?',
                fieldSet: ['15-19 years old', '20-24 years old', '25-34 years old', '35-44 years old', '45-54 years old', 'Over 55 years old'],
                inline: true,
                bind: 'ageRange'
            },
            {
                type: 'radio',
                label: 'Are you likely to utilize recreational facilities if so provided by the District?',
                fieldSet: ['Yes', 'No'],
                inline: true,
                bind: 'recFacilities'
            },
            {
                type: 'checkbox',
                label: 'What amenities would you like to see along potential future walking paths in the District?',
                fieldSet: ['Workout stations', 'Shade structures',
                    'Dog waste stations', 'Benches', 'Mile/Distance markers'],
                inline: false,
                bind: 'mobility'
            },
            {
                type: 'checkbox',
                label: 'What facilities would you like to see in potential future "pocket parks" in the District?',
                fieldSet: ['Traditional features (swings, merry-go-round, etc.)', 'Sensory/interactive features',
                    'Climbing features', 'Benches'],
                inline: false,
                bind: 'pocketParks'
            },
        ],
        [
            {
                type: 'empty',
                bind: 'empty'
            },
        ],
    ]

    const content = (
        <>
            {FORM_FIELDS[page].map(field => {
                let result
                switch (field.type) {
                    case 'radio':
                        result = (
                            <div className={FIELD_WRAP}>
                                <p className={LABEL}>{field.label}</p>
                                {field.fieldSet.map(setInput => (
                                    <span key={setInput} className={field.inline ? 'inline-block' : ''}>
                                        <label className={field.inline ? RADIO_TEXT_SHORT : RADIO_TEXT}>
                                            <input className={RADIO} type="radio" onChange={handleChange}
                                                checked={data[field.bind] == setInput}
                                                name={field.bind}
                                                value={setInput}
                                            />{setInput}
                                        </label>{field.inline ? '' : (<br />)}
                                    </span>
                                ))}
                            </div>
                        )
                        break
                    case 'checkbox':
                        result = (
                            <div className={FIELD_WRAP}>
                                <p className={LABEL}>{field.label} <small className="text-neutral-900 dark:text-neutral-400">(Select all that apply)</small></p>
                                {field.fieldSet.map(setInput => (
                                    <span key={setInput} className={field.inline ? 'inline-block' : ''}>
                                        <label className={field.inline ? RADIO_TEXT_SHORT : RADIO_TEXT}>
                                            <input className={RADIO} type="checkbox"
                                                checked={!!data[field.bind][setInput]}
                                                name={field.bind}
                                                onChange={event => handleCheckboxChange(event, setInput)}
                                            />{setInput}
                                        </label>{field.inline ? '' : (<br />)}
                                    </span>
                                ))}
                            </div>
                        )
                        break
                    case 'email':
                        result = (
                            <div className={FIELD_WRAP}>
                                <label htmlFor={field.bind} className={LABEL}>{field.label} <small className="text-rose-900 dark:text-rose-400">(Required)</small></label>
                                <input
                                    className={INPUT_TEXT}
                                    type="email"
                                    name={field.bind}
                                    placeholder="user@example.com"
                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                    value={data[field.bind]}
                                    onChange={handleChange}
                                />
                            </div>
                        )
                        break
                    case 'text':
                        result = (
                            <div className={FIELD_WRAP}>
                                <label htmlFor={field.bind} className={LABEL}>{field.label}</label>
                                <input
                                    className={INPUT_TEXT}
                                    type="text"
                                    name={field.bind}
                                    placeholder={field.placeholder}
                                    value={data[field.bind]}
                                    onChange={handleChange}
                                />
                            </div>
                        )
                        break
                    case 'textbox':
                        result = (
                            <div className={FIELD_WRAP}>
                                <label htmlFor={field.bind} className={LABEL}>{field.label}</label>
                                <textarea
                                    className={INPUT_TEXT}
                                    name={field.bind}
                                    placeholder={field.placeholder}
                                    value={data[field.bind]}
                                    onChange={handleChange}
                                ></textarea>
                            </div>
                        )
                        break
                    default:
                        result = (
                            <div className="bg-green-100 rounded-md p-8">
                                <h4 className="font-medium text-lg text-center">Your Response has been recorded</h4>
                            </div>
                        )
                }
                return (<div key={field.bind}>{result}</div>)
            })}

        </>
    )

    return content
}
export default FormInputs
